// @ts-nocheck
import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    DispatchBeginPlaceOrderForApproval,
    DispatchCompletePlaceOrderForApproval,
    DispatchResetOrders,
    DispatchResetQuotes,
    ExecuteOnSuccessCallback,
    ReloadCurrentCart,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import { createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

interface AddPoNumberToCart {
    poNumber: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    AddPoNumberToCart & HasOnSuccess<string>,
    UpdateCartApiParameter,
    CartResult
>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const cartId = state.pages?.checkoutReviewAndSubmit?.cartId;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);

    if (!cartState.value) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    props.apiParameter = {
        cart: {
            ...cartState.value,
            status: "AwaitingApproval",
            // Store Custom Code
            poNumber: props.parameter.poNumber,
        },
    };
};

export const chain = [
    DispatchBeginPlaceOrderForApproval,
    PopulateApiParameter,
    UpdateCart,
    ReloadCurrentCart,
    ExecuteOnSuccessCallback,
    DispatchCompletePlaceOrderForApproval,
    DispatchResetOrders,
    DispatchResetQuotes,
];

const placeOrderForApproval = createHandlerChainRunner(chain, "PlaceOrderForApproval");
export default placeOrderForApproval;
